import { useEffect } from 'react';

import { ProjectMemberRole, Team, useListTeamsQuery } from '@graphql/generated';
import { useGetTeamAvatarsByIdsQuery } from '@hooks/useGetTeamAvatarsByIdsQuery';

import type { WatchQueryFetchPolicy } from '@apollo/client';

interface ListTeamsFromQueryProps {
  role?: ProjectMemberRole;
  includePending?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}

export const useListTeamsFromQuery = (props?: ListTeamsFromQueryProps) => {
  const {
    data: { listTeams } = {},
    loading,
    error,
    refetch,
  } = useListTeamsQuery({
    variables: {
      role: props?.role,
      includePending: props?.includePending || false,
    },
    fetchPolicy: props?.fetchPolicy ?? 'cache-and-network',
  });
  const teams = (listTeams || []).map((t) => {
    if (t.personal) {
      return { ...t, name: 'Personal Projects' };
    }

    return t;
  }) as Team[];

  const { checkTeamAvatarURLByIds } = useGetTeamAvatarsByIdsQuery();

  useEffect(() => {
    const avatarIds = new Set<string>();
    teams.forEach((p) => {
      if (p.avatarFile?.id) {
        avatarIds.add(p.avatarFile.id);
      }
    });
    checkTeamAvatarURLByIds([...avatarIds]);
  }, [teams.length]);

  const teamsWithoutPersonal = (teams || []).filter((t) => !t.personal);

  return { teams, teamsWithoutPersonal, loading, error, refetch };
};
